export default "__VITE_ASSET__BpPtHJnM__"